import { render, staticRenderFns } from "./MyLessonTest.vue?vue&type=template&id=10b24f10&scoped=true&"
import script from "./MyLessonTest.vue?vue&type=script&lang=js&"
export * from "./MyLessonTest.vue?vue&type=script&lang=js&"
import style0 from "./MyLessonTest.vue?vue&type=style&index=0&id=10b24f10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b24f10",
  null
  
)

export default component.exports